































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import arrayCrdtSortNumber from 'src/assets/arrayCrdtSortNumber'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import SlidesEditorCreateButtons from 'components/presenter/item/topic/editor/SlidesEditorCreateButtons.vue'
import SlidesEditorForm from 'components/presenter/item/topic/editor/SlidesEditorForm.vue'
import api from 'src/assets/api/gql'
import ItemAttachmentsPaste from 'src/graphql/item/ItemAttachmentsPaste.gql'
import { Item, ItemType } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    SlidesEditorCreateButtons,
    SlidesEditorForm
  }
})
export default class ItemTopicMenuButtonAdd extends Vue {
  loading = false
  slideId = ''

  @Prop()
  readonly item!: Item

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly gridSlides!: Json[]

  @Prop()
  readonly corrects!: Json

  @Prop()
  readonly afterIndex!: number | undefined

  @Prop({ default: false })
  readonly pasteOff!: boolean

  @Ref()
  readonly dialog!: DialogFullscreen

  get slide () {
    return this.slides.find((x: Json) => x.id === this.slideId)
  }

  get nextSlideSort () {
    if (this.afterIndex !== undefined) {
      if (this.afterIndex === -1) {
        if (this.gridSlides.length) {
          return arrayCrdtSortNumber(this.gridSlides, 0, 1)
        } else {
          return arrayCrdtSortNumber(this.gridSlides)
        }
      } else {
        return arrayCrdtSortNumber(this.gridSlides, this.afterIndex, -1)
      }
    } else {
      return arrayCrdtSortNumber(this.gridSlides)
    }
  }

  select () {
    this.loading = false
    this.slideId = ''
    this.dialog.show()
  }

  async create (type: string) {
    this.loading = true
    this.slideId = new Date().getTime().toString()
    const sort = type === 'Params' ? 0 : this.nextSlideSort || 0
    const slidesSettings: Json = {}
    slidesSettings[`${this.slideId}:id`] = this.slideId
    slidesSettings[`${this.slideId}:sort`] = sort
    slidesSettings[`${this.slideId}:type`] = type
    await this.item.data?.save({ slidesSettings })
    this.loading = false
  }

  async paste (paste: Json) {
    this.dialog.hide()
    await this.item.data?.save(paste.data)
    await api.mutate({
      query: ItemAttachmentsPaste,
      variables: {
        input: {
          id: this.item.id,
          files: paste.files
        }
      }
    })
  }
}
